export default "__VITE_ASSET__c37c9071__"